<script setup lang="ts">
import bbbLogoAccredited from '@consumer/assets/images/bbbrating.svg'
</script>

<template>
  <h2 class="text-xl pb-4 pt-8">
    For over 10 years, Giftly has delivered happiness to millions of customers.
  </h2>

  <p class="mb-6">
    With merchants coast to coast, you can send a gift for use at almost any business, from
    local favorites to nationwide chains. Treat friends and family to places they'll enjoy.
  </p>

  <div class="flex gap-8 justify-left items-center">
    <img :src="bbbLogoAccredited" height="52" width="137">
    <div
      class="trustpilot-widget"
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="5aa773d465a75300015d8d3b"
      data-style-height="56px"
      data-style-width="140px"
      data-theme="light"
    >
      <a
        href="https://www.trustpilot.com/review/giftly.com"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
    </div>
  </div>
</template>
